<ngx-charts-line-chart
  [view]="view"
  [scheme]="colorScheme"
  [results]="chartData"
  [gradient]="gradient"
  [xAxis]="showXAxis"
  [yAxis]="showYAxis"
  [showXAxisLabel]="showXAxisLabel"
  [showYAxisLabel]="showYAxisLabel"
  [xAxisTickFormatting]="xAxisTickFormatting"
  [legend]="showLegend"
  [legendPosition]="legendPosition"
  [autoScale]="autoScale">
</ngx-charts-line-chart>
